<div class="row justify-content-center mt-4">
    <div class="col-auto" (click)="closeModal()">
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="18" cy="18" r="18" fill="#C9D5DB" />
            <g clip-path="url(#clip0_593_7335)">
                <path
                    d="M10.2928 10.2928C10.4803 10.1054 10.7346 10.0001 10.9998 10.0001C11.265 10.0001 11.5193 10.1054 11.7068 10.2928L17.9998 16.5858L24.2928 10.2928C24.385 10.1973 24.4954 10.1211 24.6174 10.0687C24.7394 10.0163 24.8706 9.98874 25.0034 9.98759C25.1362 9.98643 25.2678 10.0117 25.3907 10.062C25.5136 10.1123 25.6253 10.1865 25.7192 10.2804C25.8131 10.3743 25.8873 10.486 25.9376 10.6089C25.9879 10.7318 26.0132 10.8635 26.012 10.9962C26.0109 11.129 25.9833 11.2602 25.9309 11.3822C25.8785 11.5042 25.8023 11.6146 25.7068 11.7068L19.4138 17.9998L25.7068 24.2928C25.8889 24.4814 25.9897 24.734 25.9875 24.9962C25.9852 25.2584 25.88 25.5092 25.6946 25.6947C25.5092 25.8801 25.2584 25.9852 24.9962 25.9875C24.734 25.9898 24.4814 25.889 24.2928 25.7068L17.9998 19.4138L11.7068 25.7068C11.5182 25.889 11.2656 25.9898 11.0034 25.9875C10.7412 25.9852 10.4904 25.8801 10.305 25.6947C10.1196 25.5092 10.0144 25.2584 10.0121 24.9962C10.0098 24.734 10.1106 24.4814 10.2928 24.2928L16.5858 17.9998L10.2928 11.7068C10.1053 11.5193 10 11.265 10 10.9998C10 10.7347 10.1053 10.4804 10.2928 10.2928V10.2928Z"
                    fill="#212529" />
            </g>
            <defs>
                <clipPath id="clip0_593_7335">
                    <rect width="16" height="16" fill="white" transform="translate(10 10)" />
                </clipPath>
            </defs>
        </svg>
    </div>
</div>
<div class="card">
    <div class="card-body">
        <h5>
            Clip Include/Exclude in Video
        </h5>
        <p>
            The thumbnail marked with (x) signifies the option to remove the clip from the final video, while the thumbnail marked with (+) signifies the option to retain the clip in the final video.
        </p>


        <h5 class="mt-4">
            Clip Re-Order
        </h5>
        <p>
            You now have the ability to adjust the sequence of clips by simply swiping the thumbnails.
        </p>
    </div>
</div>